import { Typography, makeStyles } from '@material-ui/core'
import React from 'react'

const useStyles = makeStyles(() => ({
    buttonRoot: {
        width: '45%',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        justifyContent: 'center',
        alignItems: 'center',
        aspectRatio: '1/1',
        boxShadow: '0px 0px 10px rgba(0,0,0,0.15)', 
        padding: '1rem',
        textAlign: 'center',
        userSelect: 'none',
        cursor: 'pointer',
        maxHeight: '400px',
        
    }
}))

export default function BlueprintCreateButtons({data, onClick}) {
  const classes = useStyles();
  return (
    <div className={classes.buttonRoot} data-ui-tour-id={data?.id} id={data?.id} onClick={() => onClick(data?.id)}>
        <Typography variant='h6' style={{fontSize: '1rem'}}>{data?.name}</Typography>
        <Typography style={{textAlign: 'center'}}>{data?.description}</Typography>
    </div>
  )
}
